import type React from "react";
import { createContext, useContext } from "react";

// Generic context for Better Feature client
const BetterFeatureContext = createContext<unknown | null>(null);

// Provider component
export interface BetterFeatureProviderProps<T = unknown> {
	client: T;
	children: React.ReactNode;
}

export const BetterFeatureProvider = <T,>({
	client,
	children,
}: BetterFeatureProviderProps<T>) => {
	return (
		<BetterFeatureContext.Provider value={client}>
			{children}
		</BetterFeatureContext.Provider>
	);
};

// Hook to use the feature client
export const useBetterFeatureClient = <T extends {}>(): T => {
	const client = useContext(BetterFeatureContext);

	if (!client) {
		throw new Error(
			"useBetterFeatureClient must be used within a BetterFeatureProvider. " +
				"Make sure to wrap your app with BetterFeatureProvider and pass the Better Feature client.",
		);
	}

	return client as T;
};
